<!-- 商业信息管理 -->
<script setup>
// import i18n from "@/i18n"
// import flatPickr from "vue-flatpickr-component";
import { reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import tableCom from "./components/table.vue"
import { getLangValue } from "@/utils/common"; //获取后端语言
// import examineCom from "./components/examine.vue"
const route = useRoute()
const PageHeaderT = getLangValue('business-product', "title")
const PageHeaderItems = [
    {
        href: `/business_products_management?search_type=${route.query.search_type || 0}`,
        text: getLangValue('business-product', "title"),
        active: false,
    },
    {
        text: getLangValue('business-product', "subtitle"),
        active: true,
    },
]
const router = useRouter()

const tabList = ref([
    { name: getLangValue('business-product', "tab1"), number: 0, id: 0, },
    { name: getLangValue('business-product', "tab2"), number: 0, id: 3, },
    { name: getLangValue('business-product', "tab3"), number: 0, id: 1, },
    { name: getLangValue('business-product', "tab4"), number: 0, id: 2, },
])
const tableRef = ref(null)
// const examineRef = ref(null)
const current_tab = ref(route.query.search_type || 0)
// const showIndex = ref(0) // 0-table 1-examine 2-detail 
const searchData = reactive({
    type: 0,
    keyword: '',
    date: null,
})
/**
 * 搜索部分
 */
const search = () => {
    // console.log(searchData);
    // 如果完全一样
    // 手动去吊接口
    if (tableRef.value.searchInfo.type == searchData.type && tableRef.value.searchInfo.keyword == searchData.keyword && tableRef.value.searchInfo.date == searchData.date) {
        tableRef.value.currentPage = 1;
        tableRef.value.getDataList();
    }
    tableRef.value.searchInfo.type = searchData.type
    tableRef.value.searchInfo.keyword = searchData.keyword
    tableRef.value.searchInfo.date = searchData.date
    // if (searchData.date == '' || searchData.date == null) {
    //     tableRef.value.searchInfo.date = ''
    // } else if (!searchData.date.includes('to')) {
    //     tableRef.value.searchInfo.date = `${searchData.date} to ${searchData.date}`
    // } else {
    //     tableRef.value.searchInfo.date = searchData.date;
    // }
}
const handlerToggleTab = (id) => {
    current_tab.value = id
    // 搜索数据 控制参数
    searchData.type = id
    search()
}

const reset = () => {
    searchData.keyword = ''
    searchData.date = null
    search()
}

const updateTabData = (data) => {
    // 设置tab数据
    // 假数据
    tabList.value[0].number = data.wait_review_total
}

/***
 * 切换信息部分
 * 
 */
const viewTabData = (info) => {
    console.log(info);
    // showIndex.value = 1
    // examineRef.value.currendData = info
    // examineRef.value.currendData = 
    router.push({ path: 'business_products_management_examine', query: { id: info.id } })
}




</script>
<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <div style="overflow-x: auto; overflow-y: hidden; height: calc(100vh - 160px);border-radius: 0.25rem;">
            <div class="w-100 h-100 bg-white">
                <div class="p-4 d-flex justify-content-between align-items-center "
                    style="box-shadow: none; font-size: 16px; font-weight: bold; color: #495057;height: 78px;">
                    {{ getLangValue('business-product', "subtitle") }}
                    <button style="opacity: 0;">
                        <i class="ri-add-fill me-1 align-bottom"></i>
                        {{ $t("product_template.add") }}
                    </button>
                </div>
                <div class="px-4 py-2" style="border-top: 1px dashed #E9EBEC;">
                    <!-- 搜索信息 -->
                    <div class="search d-flex align-items-center justify-content-between " style="">
                        <!-- Basic example -->
                        <div style="flex: 1;" class="d-flex">
                            <div class="form-icon" style="max-width: 522px; display: inline-block;flex: 1;">
                                <input clearable type="text" class="form-control form-control-icon"
                                    v-model="searchData.keyword"
                                    :placeholder="getLangValue('business-product', 'search_placeholder')" />
                                <i class="ri-search-line"></i>
                            </div>
                            <!-- 日期 -->
                            <!-- mode: 'range', -->
                            <!-- <div style="position: relative;display: inline-block;">
                                <flat-pickr style="width: 252px;display: inline-block;" v-model="searchData.date"
                                    :placeholder="getLangValue('business-product', 'search_placeholder1')"
                                    :config="{ enableTime: false, dateFormat: 'Y-m-d', mode: 'range', }"
                                    class="form-control mx-2"></flat-pickr>
                                <i @click="searchData.date = ''" class="ri-close-circle-fill cursor-pointer"
                                    style="position: absolute; right: 16px; top: 10px; color: #435185;"
                                    v-if="searchData.date != null"></i>
                            </div> -->
                            <div class="w-10 mx-2" style="position: relative; flex: 1;">
                                <el-date-picker style="height: 37.5px;" v-model="searchData.date" type="daterange"
                                    range-separator="-" :start-placeholder="getLangValue('base.start_date')"
                                    :end-placeholder="getLangValue('base.end_date')" size="large"
                                    value-format="YYYY-MM-DD" />
                            </div>
                        </div>
                        <!-- 按钮 -->
                        <div class="d-flex justify-content-end">
                            <b-button variant="success" @click="search"
                                style="min-width: 100px; background-color: #405189; display: flex; align-items: center;border-color: unset; justify-content: center;">
                                <i class="ri-search-line me-1"></i>{{ getLangValue('base.search') }}
                            </b-button>
                            <b-button class="mx-2" variant="success" @click="reset"
                                style="min-width: 100px;background-color: #299CDB;display: flex; align-items: center;border-color: unset; justify-content: center;">
                                <i class="ri-refresh-line me-1"></i> {{ getLangValue('base.reset') }}
                            </b-button>
                        </div>
                    </div>
                </div>
                <!-- tab搜索 -->
                <ul class="nav nav-tabs nav-tabs-custom nav-success d-flex align-items-center " role="tablist"
                    style="border-bottom: 1px solid #E9EBEC; padding: 0;">
                    <li class="nav-item" v-for="(tab, i) in tabList" :key="i"
                        style="min-width: 115px; text-align: center;">
                        <a :class="[
                            'nav-link',
                            'All',
                            'position-relative cursor',
                            tab.id == current_tab && 'active',
                        ]" @click="handlerToggleTab(tab.id)"
                            style="color: #405189; font-weight: 600; font-size: 13px; display: flex; align-items: center;">
                            {{ tab.name }}
                            <span class="badge bg-primary-subtle ms-1" v-if="tab.number > 0"
                                style="background-color: #F0654819; background-color: #F06548; padding: 4px 6px; border-radius: 4px;">{{
                                    tab.number }}</span>
                        </a>

                    </li>
                </ul>
                <!-- 表格数据 -->
                <tableCom ref="tableRef" @updateTabData="updateTabData" @viewTabData="viewTabData" />
            </div>
            <!-- <div class="w-100 h-100 bg-white card p-4" v-show="showIndex == 1" style="overflow-y: auto;">
                <examineCom ref="examineRef" />
            </div> -->
        </div>
    </Layout>

</template>
<style lang="scss">
.el-date-editor .el-range-input {
    font-size: 0.8125rem !important;
    ;
    color: #212529 !important;

    &::placeholder {
        color: #878a99 !important;
    }
}

.el-date-range-picker__header button {
    margin-top: 0 !important;
}
</style>